export default __webpack_public_path__ + "static/media/titlescreen.78881b3a.png";